import * as Haptics from 'expo-haptics';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import {
  Platform,
  StyleProp,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import { SvgProps } from 'react-native-svg';

export interface Props {
  accessibilityLabel: string;
  count?: number;
  Icon?: React.ComponentType<SvgProps>;
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
}

export const Indicator: React.FC<Props> = ({
  accessibilityLabel,
  count,
  Icon,
  onPress,
  style,
}) => {
  const [styles, theme] = useStyles();
  return (
    <TouchableOpacity
      accessibilityLabel={accessibilityLabel}
      hitSlop={{ bottom: 10, left: 10, right: 10, top: 10 }}
      onPress={() => {
        if (Platform.OS !== 'web') {
          Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
        }
        onPress();
      }}
      style={[styles.container, style]}
    >
      <View style={styles.row}>
        {count ? (
          <Text style={[FONTS.primaryBold, styles.indicatorText]}>
            {count > 99 ? '99+' : count}
          </Text>
        ) : null}
        {Icon ? (
          <Icon
            height={12}
            stroke={theme.sk.color.text.secondary}
            style={styles.icon}
            width={12}
          />
        ) : null}
      </View>
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    alignSelf: 'center',
    backgroundColor: theme.sk.color.bg.tertiary.default,
    borderColor: theme.colors.primary,
    borderRadius: 48,
    justifyContent: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  icon: {
    alignSelf: 'center',
  },
  indicatorText: {
    color: theme.sk.color.text.secondary,
    fontSize: 12,
  },
  row: {
    flexDirection: 'row',
    gap: 3,
  },
}));
